export const __DEV__ = process.env.NODE_ENV === 'development';
export const __PROD__ = process.env.NODE_ENV === 'production';
export function isObject(value) {
    return typeof value === 'object' && value !== null;
}
export function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'symbol' ||
        typeof value === 'bigint');
}
export function isFunction(value) {
    return typeof value === 'function' && typeof value !== 'object';
}
export function isUndefined(value) {
    return typeof value === 'undefined';
}
export function isNull(value) {
    return value === null;
}
export function isNill(value) {
    return isUndefined(value) || isNull(value);
}
export function isString(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=asserts.js.map